import axios from '@/shared/utils/axios-init';

const initialState = {
  requestsData: [],
  confirmDialog: false,
  cancelItemId: '',
};


const getters = {
  getRequestsData(state) {
    return state.requestsData;
  },
  confirmDialogState(state) {
    return state.confirmDialog;
  },
  getCancelItemId(state) {
    return state.cancelItemId;
  },
};

const mutations = {
  setRequestsData(state, data) {
    state.requestsData = data;
  },
  toggleConfirmDialog(state, data) {
    state.confirmDialog = data;
  },
  setCancelItemId(state, data) {
    state.cancelItemId = data;
  },
  deleteRequest(state, requestId) {
    const requestIndex = state.requestsData.findIndex((element) => {
      if (element.order_id === requestId) {
        return true;
      }
      return false;
    });
    state.requestsData.splice(requestIndex, 1);
  },
};

const actions = {
  async fetchRequestsData({ commit, rootState }, currencies) {
    const pair = {
      base: currencies.baseCurrency,
      quoted: currencies.quoteCurrency,
    };

    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const data = await axios.post('/orders/my', pair, { headers: { Authorization: `Bearer ${token}` } });
      const requestsData = data.data.list;

      commit('setRequestsData', requestsData);

      return data;
    } catch (error) {
      commit('setRequestsData', []);
      return error.response;
    }
  },
  async cancelRequest({ commit, rootState }, request) {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const data = await axios.post('/orders/my/cancel', request, { headers: { Authorization: `Bearer ${token}` } });

      commit('deleteRequest', request.order_id);
      commit('account/requests/deleteRequest', request.order_id, { root: true });

      return data;
    } catch (error) {
      return error.response;
    }
  },
};


export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/modules/Dashboard/modules/requests.js